<template>
    <v-card hover raised class="text-xs-center">
        <v-card-title primary-title>
            <h3 class="headline mb-0">Solicitudes de No Conformidades</h3>
            <v-spacer></v-spacer>
            <slot name="opciones"></slot>
        </v-card-title>
        <v-card-text>
            <v-card-text class="text-xs-left">
                <v-container fluid v-if="loading">
                    <v-layout>
                        <v-flex xs12 justify-center align-center class="text-xs-center">
                            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-container>
                <template v-for="(s,index) in solicitudes">
                    <v-layout align-center>
                        <v-flex>
                            ID incidencia: <b>{{ s.id }}</b>
                            <br>
                            Fecha de creación de incidencia: <b>{{ s.created_at }}</b>
                            <br>
                            Origen: <b>{{ (s.origen)?s.origen.desig : '' }}</b>
                            <br>
                            Resumen: <b>{{ s.resumen }}</b>
                            <br>
                            Usuario <b>{{ s.usuario.name }}</b>
                            <br>
                            Etapa: <b>{{ (s.etapa)?s.etapa.desig: '' }}</b>
                        </v-flex>
                        <v-flex>
                            <v-layout>
                                <v-flex>
                                    <v-btn icon flat color="green" :loading="aceptando === s.id" @click="aprobar(s)">
                                        <v-icon>fa-thumbs-up</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex>
                                    <v-btn icon flat color="red" :loading="rechazando === s.id" @click="obsConfirmar(s)">
                                        <v-icon>fa-thumbs-down</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                </template>
            </v-card-text>
        </v-card-text>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Rechazo de solicitud</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-textarea label="Observaciones" v-model="obs"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="rechazar" flat color="green">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import mixinIncidencias from '../../mixins/calidad/incidencia';
    import {mapActions} from 'vuex';

    export default {
        name: "SolicitudesCalidad",
        mixins: [mixinIncidencias],
        data() {
            return {
                solicitudes: [],
                loading: false,
                aceptando: -1,
                rechazando: -1,
                dialog: false,
                obs: '',
                s: {}
            }
        },
        mounted() {
            this.datos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.loading = true;
                this.incidenciaPendientes({}, r => {
                    this.solicitudes = r;
                    this.loading = false;
                }, err => {
                    console.log(err)
                    this.loading = false;
                })
            },
            aprobar(s) {
                this.aceptando = s.id;
                this.incidenciaAprobar(s, r => {
                    this.aceptando = -1;
                    this.datos();
                    this.msjShow(r);
                }, err => {
                    this.aceptando = -1;
                    this.msjShow({tipo: 2, txt: 'Error al intentar aprobar etapa'});
                })
            },
            rechazar() {
                this.dialog = false;
                this.rechazando = this.s.id;
                this.incidenciaRechazar(this.s, r => {
                    this.rechazando = -1;
                    this.datos();
                    this.msjShow(r);
                }, err => {
                    this.rechazando = -1;
                    this.msjShow({tipo: 2, txt: 'Error al intentar desaprobar etapa'});
                })
            },
            obsConfirmar(s) {
                s.obs = this.obs;
                this.s = s;
                this.dialog = true;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/SolicitudesCalidad.vue